/*
 * @Author: Czy
 * @Date: 2024-09-18 13:44:22
 * @FilePath: /bikecat/src/store/user.ts
 *
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { Logout } from '@/service/user/user'
import { useSearchStore } from '@/store'

export const useUserStore = defineStore(
  'user',
  () => {
    const userInfo = ref<IUserInfo>({})
    const setUserInfo = (val: IUserInfo) => {
      Object.assign(userInfo.value, val)
    }

    const clearUserInfo = () => {
      userInfo.value = {}
    }
    // 一般没有reset需求，不需要的可以删除
    const reset = () => {
      userInfo.value = {}
    }
    // 不再需要登录，始终视为已登录状态
    const isLogined = computed(() => true)

    const logout = async () => {
      const res = await Logout()
      clearUserInfo()

      useSearchStore().hotelCityInfo = {}
      useSearchStore().hotelHistoryCity = []
      useSearchStore().resetHotelCityInfo()
      uni.showToast({
        icon: 'none',
        title: t('user.logoutSuccess'),
        success: () => {
          uni.reLaunch({ url: '/pages/index/index' })
        },
      })
    }
    // 不再需要登录拦截，直接执行回调
    const judgeLogin = (callback?: () => void) => {
      callback?.()
    }

    return {
      userInfo,
      setUserInfo,
      clearUserInfo,
      isLogined,
      reset,
      logout,
      judgeLogin,
    }
  },
  {
    persist: true,
  },
)
